import { useEffect, useState } from "react";
import Quizz from "../../components/Quizz/Quizz";
import BasicPage from "../../components/baseComponents/basicPage/BasicPage";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";

import { IonButton } from "@ionic/react";
import PDFViewer from "../../components/Book/Viewer";
import { titleSection } from "../../components/Video/Video";
import jsonQuestion from "./quizzExemple.json";
import Synthesis from "../../components/Video/Synthesis";

interface Theme {
  pictureUrl: string;
  _id: string;
  name: string;
  quizz?: any;
  synthesis: any;
  synthesisDone: boolean;
  file?: string;
  fileUrl?: string;
}

const FormalPratiqueTheme: React.FC = () => {
  const ids =
    window.location.pathname.split("/formalPratique/")[1].split("/") ?? "";
  const themeID = ids[1] ?? "";

  const [theme, setTheme] = useState<Theme>();
  const [fileUrl, setFileUrl] = useState<string>("");
  const [done, setDone] = useState<boolean>(false);

  const exempleQuizz = jsonQuestion;

  useEffect(() => {
    makeGETRequest("/me").then((res) => {
      makeGETRequest(
        "/mark/unique?email=" + res.email + "&id_thing=" + themeID
      ).then((res) => {
        if (res && res.length > 0) {
          setDone(true);
        }
      });
    });
    makeGETRequest("/theme?_id=" + themeID).then((res) => {
      setTheme(res);
      setFileUrl(res.fileUrl);
    });
  }, []);

  return (
    <BasicPage
      pathLogo={""}
      subtitle=""
      title={theme?.name ?? ""}
      pathReturn="welcome"
    >
      {localStorage.getItem("techno") !== "char" ? (
        <>
          {titleSection("1 Les quiz :" + " teste tes connaissances")}
          {/* <Quizz questions={theme?.quizz} _id={theme?._id ?? ""} /> */}
        </>
      ) : null}

      {titleSection("1 La synthèse :" + " approfondis tes connaissances")}
      <div className="ion-justify-content-center flex">
        {theme?.synthesis ? (
          <Synthesis
            label="Exerces-toi"
            idVideo={themeID}
            data={theme?.synthesis}
          />
        ) : null}
      </div>

      {titleSection("2 Les ressources :" + " revoir le cours")}
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            transform: "translateX(-10%)",
            height: 700,
            width: 1000,
          }}
        >
          {fileUrl && done ? (
            <PDFViewer fileURL={fileUrl} setBookLoader={() => {}} />
          ) : null}
          <div
            style={{
              marginBottom: 100,
              paddingBottom: 100,
            }}
          ></div>
        </div>
      </div>
    </BasicPage>
  );
};

export default FormalPratiqueTheme;
